import type React from "react"
import { useState } from "react"
import {
  SpinnerStroke,
  SpinnerTail,
  SpinnerThrobbing,
  SpinnerWheel,
} from "./spinner"

type SpinnerTypes = "stroke" | "throbbing" | "tail" | "wheel"
export interface SpinnerLoaderProps {
  type?: SpinnerTypes
  size?: number
  thickness?: number
  colorPrimary?: string
  colorSecondary?: string
  /**
   * Duration of one rotation in seconds
   */
  duration?: number
}

export const SpinnerLoader: React.FC<SpinnerLoaderProps> = ({
  type,
  size = 46,
  thickness = 3,
  colorPrimary = "primary",
  colorSecondary = "#0077c022",
  duration = 1.1,
}) => {
  const [background, setBackground] = useState("white")

  function discoverBackgroundColor(node: HTMLDivElement | null) {
    if (!node || !node.parentElement) return
    let el: HTMLElement | null = node.parentElement
    let bg = "white"

    while (el !== null) {
      const curBg = window
        .getComputedStyle(el, null)
        .getPropertyValue("background-color")

      if (
        curBg !== "rgba(0, 0, 0, 0)" &&
        curBg !== "transparent" &&
        curBg !== ""
      ) {
        bg = curBg
        break
      }

      if (el.tagName === "BODY") break
      el = el.parentElement
    }

    setBackground(bg)
  }

  switch (type) {
    case "throbbing":
      return (
        <SpinnerThrobbing
          ref={(node) => discoverBackgroundColor(node)}
          size={size}
          thickness={thickness}
          colorPrimary={colorPrimary}
          background={background}
          duration={duration}
        />
      )
    case "tail":
      return (
        <SpinnerTail
          size={size}
          colorPrimary={colorPrimary}
          duration={duration}
        />
      )
    case "wheel":
      return (
        <SpinnerWheel
          size={size}
          colorPrimary={colorPrimary}
          duration={duration}
        >
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </SpinnerWheel>
      )
    default:
      return (
        <SpinnerStroke
          size={size}
          thickness={thickness}
          colorPrimary={colorPrimary}
          colorSecondary={colorSecondary}
          duration={duration}
        />
      )
  }
}
